module.exports = __webpack_public_path__ + "static/img/pic200-12.40f49e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic200-12.png
// module id = Wlit
// module chunks = 43